// import React, { useState } from 'react';
// import { Link, Outlet } from 'react-router-dom';
// import { Navbar, Nav, Container } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import "bootstrap-icons/font/bootstrap-icons.css";
// import './AdminDash.css';

// // DashboardSidebar
// const DashboardSidebar = () => {
//     const [userDropdownOpen, setUserDropdownOpen] = useState(false);
//     const [servitorDropdownOpen, setServitorDropdownOpen] = useState(false);

//     const toggleUserDropdown = () => {
//         setUserDropdownOpen(!userDropdownOpen);
//         if (servitorDropdownOpen) setServitorDropdownOpen(false); // Close Servitor dropdown if open
//     };

//     const toggleServitorDropdown = () => {
//         setServitorDropdownOpen(!servitorDropdownOpen);
//         if (userDropdownOpen) setUserDropdownOpen(false); // Close User dropdown if open
//     };

//     return (
//         <div className="admin-sidebar">
//             <div className="sidebar-header">
//                 <span className="sidebar-brand">HelpNao</span>
//             </div>
//             <hr className="sidebar-divider" />
//             <ul className="sidebar-nav">
//                 <li className="nav-item">
//                     <Link to="/dashboard" className="admin-nav-link">
//                         <i className="bi bi-speedometer2"></i> Dashboard
//                     </Link>
//                 </li>
//                 <li className="nav-item">
//                     <Link to="/admin/services" className="admin-nav-link">
//                         <i className="bi bi-tools"></i> Services
//                     </Link>
//                 </li>
//                 <li className="nav-item">
//                     <div
//                         className={`admin-nav-link dropdown-toggle ${userDropdownOpen ? 'active' : ''}`}
//                         onClick={toggleUserDropdown}
//                     >
//                         <i className="bi bi-person"></i> User
//                     </div>
//                     <ul className={`dropdown-menu ${userDropdownOpen ? 'active' : ''}`}>
//                         <li className="admin-dropdown-item">
//                             <Link to="/admin/userdetails" className="admin-nav-link">
//                                 User Details
//                             </Link>
//                         </li>
//                         <li className="admin-dropdown-item">
//                             <Link to="/admin/userorders" className="admin-nav-link">
//                                 User Orders
//                             </Link>
//                         </li>
//                     </ul>
//                 </li>
//                 <li className="nav-item">
//                     <div
//                         className={`admin-nav-link dropdown-toggle ${servitorDropdownOpen ? 'active' : ''}`}
//                         onClick={toggleServitorDropdown}
//                     >
//                         <i className="bi bi-people"></i> Servitor
//                     </div>
//                     <ul className={`dropdown-menu ${servitorDropdownOpen ? 'active' : ''}`}>
//                         <li className="admin-dropdown-item">
//                             <Link to="/admin/servitordetails" className="admin-nav-link">
//                                 Details
//                             </Link>
//                         </li>
//                         <li className="admin-dropdown-item">
//                             <Link to="/admin/servitorconfirmorders" className="admin-nav-link">
//                                 Confirm Orders
//                             </Link>
//                         </li>
//                     </ul>
//                 </li>
//                 <li className="nav-item">
//                     <Link to="/admin/reports" className="admin-nav-link">
//                         <i className="bi bi-file-earmark-text"></i> Reports
//                     </Link>
//                 </li>
//             </ul>
//         </div>
//     );
// };

// const handleLogout = () => {
//     window.location.href = '/login';
// };

// const DashboardTopBar = () => {
//     return (
//         <Navbar expand="lg" className="dashboard-topbar">
//             <Container fluid>
//                 <Navbar.Toggle aria-controls="basic-navbar-nav" />
//                 <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
//                     <Nav>
//                         <Nav.Link href="#notifications" className="topbar-link">
//                             <i className="bi bi-bell"></i>
//                         </Nav.Link>
//                         <Nav.Link href="#profile" onClick={handleLogout} className="topbar-link">
//                             <i className="bi bi-person-circle"></i>
//                         </Nav.Link>
//                     </Nav>
//                 </Navbar.Collapse>
//             </Container>
//         </Navbar>
//     );
// };

// const AdminDash = () => {
//     return (
//         <div className='admin-dashboard'>
//             <DashboardSidebar />
//             <div className='dashboard-content'>
//                 <DashboardTopBar />
//                 <div className='content-container'>
//                     <Outlet />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AdminDash;

// import React, { useState, useEffect } from "react";
// import { Link, Outlet, useLocation } from "react-router-dom";
// import { Navbar, Nav, Container, Dropdown, Modal, Button, Form } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "./AdminDash.css";
// import axios from "axios";
// import { URL } from "../../config";

// const getRoleLabel = (role) => {
//   switch (Number(role)) {
//     case 1:
//       return "Founder";
//     case 2:
//       return "Super Admin";
//     case 3:
//       return "Admin";
//     default:
//       return "Admin";
//   }
// };

// const DashboardSidebar = ({ adminInfo }) => {
//   const [userDropdownOpen, setUserDropdownOpen] = useState(false);
//   const [servitorDropdownOpen, setServitorDropdownOpen] = useState(false);
//   const [reportsDropdownOpen, setReportsDropdownOpen] = useState(false);
//   const [collapsed, setCollapsed] = useState(false);
//   const location = useLocation();

//   const role = Number(adminInfo?.role);
//   const isFounder = role === 1;
//   const isSuperAdmin = role === 2;
//   const canSeeCoreAdminLinks = isFounder || isSuperAdmin; // Founder + Super Admin

//   const toggleUserDropdown = () => {
//     setUserDropdownOpen(!userDropdownOpen);
//     if (servitorDropdownOpen) setServitorDropdownOpen(false);
//   };

//   const toggleServitorDropdown = () => {
//     setServitorDropdownOpen(!servitorDropdownOpen);
//     if (userDropdownOpen) setUserDropdownOpen(false);
//   };

//    const toggleReportsDropdown = () => {
//     setReportsDropdownOpen(!reportsDropdownOpen);
//     if (userDropdownOpen) setUserDropdownOpen(false);
//     if (servitorDropdownOpen) setServitorDropdownOpen(false);
//   };

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed);
//   };

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   const isInDropdown = (paths) => {
//     return paths.some((path) => location.pathname.includes(path));
//   };

//   return (
//     <div className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}>
//       <div className="admin-sidebar-header">
//         <div className="d-flex align-items-center justify-content-between">
//           <span className="admin-sidebar-brand">
//             <i className="bi bi-grid-fill me-2"></i>
//             {!collapsed && "HelpNao"}
//           </span>
//           <button className="admin-toggle-btn" onClick={toggleSidebar}>
//             <i
//               className={`bi ${
//                 collapsed ? "bi-chevron-right" : "bi-chevron-left"
//               }`}
//             ></i>
//           </button>
//         </div>
//       </div>
//       <div className="admin-sidebar-profile">
//         <div className="admin-profile-avatar">
//           <i className="bi bi-person-circle"></i>
//         </div>
//         {/* {!collapsed && (
//           <div className="admin-profile-info">
//             <h6 className="admin-profile-name">Admin User</h6>
//             <span className="admin-profile-role">Administrator</span>
//           </div>
//         )} */}

//         {!collapsed && (
//           <div className="admin-profile-info">
//             <span className="admin-profile-role">
//               {getRoleLabel(adminInfo?.role)}
//             </span>
//             <h6 className="admin-profile-name">
//               {adminInfo?.name || "Admin User"}
//             </h6>
//             {adminInfo?.email && (
//               <small className="text-muted d-block" style={{ fontSize: "10px" }}>
//                 {adminInfo.email}
//               </small>
//             )}
//           </div>
//         )}


//       </div>
//       <hr className="admin-sidebar-divider" />
//       <ul className="admin-sidebar-nav">
//         <li className="admin-nav-item">
//           <Link
//             to="/admin/dashboard"
//             className={`admin-nav-link ${
//               isActive("/admin/dashboard") ? "active" : ""
//             }`}
//           >
//             <i className="bi bi-house-door-fill"></i>
//             {!collapsed && <span>Dashboard</span>}
//           </Link>
//         </li>

//        {canSeeCoreAdminLinks && ( 
//         <li className="admin-nav-item">
//           <Link
//             to="/admin/helpnaoadmins"
//             className={`admin-nav-link ${isActive("/admin/helpnaoadmins") ? "active" : ""}`}
//           >
//             <i className="bi bi-shield-lock-fill"></i>
//             {!collapsed && <span>All Admins</span>}
//           </Link>
//         </li>
//        )}

//        {canSeeCoreAdminLinks && ( 
//         <li className="admin-nav-item">
//           <Link
//             to="/admin/helpnaoadmins/adminactivity"
//             className={`admin-nav-link ${isActive("/admin/helpnaoadmins/adminactivity") ? "active" : ""}`}
//           >
//             <i className="bi bi-activity"></i>
//             {!collapsed && <span>Admins Activity</span>}
//           </Link>
//         </li>
//        )}


//        {canSeeCoreAdminLinks && ( 
//         <li className="admin-nav-item">
//           <Link
//             to="/admin/services"
//             className={`admin-nav-link ${
//               isActive("/admin/services") ? "active" : ""
//             }`}
//           >
//             <i className="bi bi-tools"></i>
//             {!collapsed && <span>Services</span>}
//           </Link>
//         </li>
//        )}

//        {canSeeCoreAdminLinks && ( 
//         <li className="admin-nav-item">
//           <Link
//             to="/admin/location"
//             className={`admin-nav-link ${
//               isActive("/admin/location") ? "active" : ""
//             }`}
//           >
//             <i className="bi bi-geo-alt-fill"></i>
//             {!collapsed && <span>Location</span>}
//           </Link>
//         </li>
//        )}

//         <li className="admin-nav-item">
//           <div
//             className={`admin-nav-link admin-dropdown-toggle ${
//               isInDropdown(["/admin/userdetails", "/admin/userorders"]) ||
//               userDropdownOpen
//                 ? "active"
//                 : ""
//             }`}
//             onClick={toggleUserDropdown}
//           >
//             <i className="bi bi-person-fill"></i>
//             {!collapsed && (
//               <>
//                 <span>User</span>
//                 <i
//                   className={`bi bi-chevron-${
//                     userDropdownOpen ? "down" : "right"
//                   } ms-auto`}
//                 ></i>
//               </>
//             )}
//           </div>
//           <ul className={`admin-dropdown-menu ${userDropdownOpen ? "active" : ""}`}>
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/userdetails"
//                 className={`admin-nav-link ${
//                   isActive("/admin/userdetails") ? "active" : ""
//                 }`}
//               >
//                 <i className="bi bi-person-vcard"></i>
//                 <span>User Details</span>
//               </Link>
//             </li>
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/placeordersforuser"
//                 className={`admin-nav-link ${
//                   isActive("/admin/placeordersforuser") ? "active" : ""
//                 }`}
//               >
//                 <i className="bi bi-cart-check"></i>
//                 <span>Place Order</span>
//               </Link>
//             </li>
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/userorders"
//                 className={`admin-nav-link ${
//                   isActive("/admin/userorders") ? "active" : ""
//                 }`}
//               >
//                 <i className="bi bi-bag-check"></i>
//                 <span>User Orders</span>
//               </Link>
//             </li>
//           </ul>
//         </li>
//         <li className="admin-nav-item">
//           <div
//             className={`admin-nav-link admin-dropdown-toggle ${
//               isInDropdown([
//                 "/admin/servitordetails",
//                 "/admin/servitorconfirmorders",
//               ]) || servitorDropdownOpen
//                 ? "active"
//                 : ""
//             }`}
//             onClick={toggleServitorDropdown}
//           >
//             <i className="bi bi-people-fill"></i>
//             {!collapsed && (
//               <>
//                 <span>Servitor</span>
//                 <i
//                   className={`bi bi-chevron-${
//                     servitorDropdownOpen ? "down" : "right"
//                   } ms-auto`}
//                 ></i>
//               </>
//             )}
//           </div>
//           <ul
//             className={`admin-dropdown-menu ${servitorDropdownOpen ? "active" : ""}`}
//           >
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/servitordetails"
//                 className={`admin-nav-link ${
//                   isActive("/admin/servitordetails") ? "active" : ""
//                 }`}
//               >
//                 <i className="bi bi-person-badge"></i>
//                 <span>Details</span>
//               </Link>
//             </li>
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/servitorconfirmorders"
//                 className={`admin-nav-link ${
//                   isActive("/admin/servitorconfirmorders") ? "active" : ""
//                 }`}
//               >
//                 <i className="bi bi-check-circle"></i>
//                 <span>Confirm Orders</span>
//               </Link>
//             </li>

//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/servitororderhistory"
//                 className={`admin-nav-link ${
//                   isActive("/admin/servitororderhistory") ? "active" : ""
//                 }`}
//               >
//                 {/* <i className="bi bi-check-circle"></i> */}
//                 <i className="bi bi-journal-check"></i>
//                 <span>Orders History</span>
//               </Link>
//             </li>
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/servitor-referral"
//                 className={`admin-nav-link ${
//                   isActive("/admin/servitor-referral") ? "active" : ""
//                 }`}
//               >
//                 {/* <i className="bi bi-check-circle"></i> */}
//                 <i className="bi bi-people"></i>
//                 <span>Referral Details</span>
//               </Link>
//             </li>
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/servitorfeedbackdetails"
//                 className={`admin-nav-link ${
//                   isActive("/admin/servitorfeedbackdetails") ? "active" : ""
//                 }`}
//               >
//                 {/* <i className="bi bi-check-circle"></i> */}
//                 <i className="bi bi-chat-left-text"></i>
//                 <span>Rating & Feedback</span>
//               </Link>
//             </li>

//           </ul>
//         </li>
//         {/* <li className="admin-nav-item">
//           <Link
//             to="/admin/reports"
//             className={`admin-nav-link ${
//               isActive("/admin/reports") ? "active" : ""
//             }`}
//           >
//             <i className="bi bi-bar-chart-line-fill"></i>
//             {!collapsed && <span>Reports</span>}
//           </Link>
//         </li>
//         <li className="admin-nav-item">
//           <Link
//             to="/admin/reports/financereport"
//             className={`admin-nav-link ${
//               isActive("/admin/reports/financereport") ? "active" : ""
//             }`}
//           >
//             <i className="bi bi-bar-chart-line-fill"></i>
//             {!collapsed && <span>Finance Reports</span>}
//           </Link>
//         </li>
//         <li className="admin-nav-item">
//           <Link
//             to="/admin/reports/rechargeamount"
//             className={`admin-nav-link ${
//               isActive("/admin/reports/rechargeamount") ? "active" : ""
//             }`}
//           >
//             <i className="bi bi-bar-chart-line-fill"></i>
//             {!collapsed && <span>Recharge Reports</span>}
//           </Link>
//         </li> */}


//         <li className="admin-nav-item">
//           <Link
//             to="/admin/full-building-requests"
//             className={`admin-nav-link ${
//               isActive("/admin/full-building-requests") ? "active" : ""
//             }`}
//           >
//             {/* Building icon instead of geo pin */}
//             <i className="bi bi-building"></i>
//             {!collapsed && <span>Full Building</span>}
//           </Link>
//         </li>


//          <li className="admin-nav-item">
//           <div
//             className={`admin-nav-link admin-dropdown-toggle ${
//               isInDropdown([
//                 "/admin/reports",
//                 "/admin/reports/financereport",
//                 "/admin/reports/rechargeamount",
//               ]) || reportsDropdownOpen
//                 ? "active"
//                 : ""
//             }`}
//             onClick={toggleReportsDropdown}
//           >
//             <i className="bi bi-graph-up"></i>
//             {!collapsed && (
//               <>
//                 <span>Reports</span>
//                 <i className={`bi bi-chevron-${reportsDropdownOpen ? "down" : "right"} ms-auto`}></i>
//               </>
//             )}
//           </div>
//           <ul className={`admin-dropdown-menu ${reportsDropdownOpen ? "active" : ""}`}>
//             {/* Transaction Report (root reports) */}
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/reports"
//                 className={`admin-nav-link ${isActive("/admin/reports") ? "active" : ""}`}
//               >
//                 <i className="bi bi-receipt"></i>
//                 <span>Transaction Report</span>
//               </Link>
//             </li>

//             {/* Recharge Report */}
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/reports/rechargeamount"
//                 className={`admin-nav-link ${isActive("/admin/reports/rechargeamount") ? "active" : ""}`}
//               >
//                 <i className="bi bi-lightning-charge"></i>
//                 <span>Recharge Report</span>
//               </Link>
//             </li>

//             {/* Finance Report */}
//             <li className="admin-dropdown-item">
//               <Link
//                 to="/admin/reports/financereport"
//                 className={`admin-nav-link ${isActive("/admin/reports/financereport") ? "active" : ""}`}
//               >
//                 <i className="bi bi-wallet2"></i>
//                 <span>Finance Report</span>
//               </Link>
//             </li>

//           </ul>
//         </li>


//         <li className="admin-nav-item">
//           <Link
//             to="/admin/helpsupport/reports"
//             className={`admin-nav-link ${
//               isActive("/admin/helpsupport/reports") ? "active" : ""
//             }`}
//           >
//             {/* <i class="bi bi-exclamation-triangle"></i> */}
//             <i class="bi bi-headset"></i>
//             {/* {!collapsed && <span>Support Report</span>} */}
//             {!collapsed && <span>Issue Reports</span>}
//           </Link>
//         </li>

//         <li className="admin-nav-item">
//           <Link
//             to="/admin/helpsupport/contactuslist"
//             className={`admin-nav-link ${
//               isActive("/admin/helpsupport/contactuslist") ? "active" : ""
//             }`}
//           >
//             {/* <i class="bi bi-exclamation-triangle"></i> */}
//             <i className="bi bi-chat-left-dots"></i>
//             {/* {!collapsed && <span>Support Report</span>} */}
//             {!collapsed && <span>Contact Message</span>}
//           </Link>
//         </li>
        

//       </ul>
//       <div className="admin-sidebar-footer">
//         <div
//           className="admin-logout-btn"
//           onClick={() => {
//                     localStorage.removeItem("adminToken");
//                     localStorage.removeItem("adminInfo");
//                     window.location.href = "/HelpNaoadminpannel/login";
//                   }}
//         >
//           <i className="bi bi-box-arrow-right"></i>
//           {!collapsed && <span>Logout</span>}
//         </div>
//       </div>
//     </div>
//   );
// };

// const DashboardTopBar = ({ adminInfo }) => {
//   const [notifications, setNotifications] = useState([
//     { id: 1, message: "New user registered", time: "2 min ago", type: "user" },
//     { id: 2, message: "New order placed", time: "10 min ago", type: "order" },
//     {
//       id: 3,
//       message: "System update completed",
//       time: "1 hour ago",
//       type: "system",
//     },
//   ]);

//   const [showPasswordModal, setShowPasswordModal] = useState(false);
//   const [passwordForm, setPasswordForm] = useState({
//     currentPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [pwError, setPwError] = useState("");
//   const [pwSuccess, setPwSuccess] = useState("");


//   const [showCurrentPassword, setShowCurrentPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   const getNotificationIcon = (type) => {
//     switch (type) {
//       case "user":
//         return "bi-person-plus";
//       case "order":
//         return "bi-bag-plus";
//       case "system":
//         return "bi-gear";
//       default:
//         return "bi-bell";
//     }
//   };

//   const handleClearNotifications = () => {
//     setNotifications([]);
//   };


//     const handleOpenPasswordModal = () => {
//     setPwError("");
//     setPwSuccess("");
//     setPasswordForm({
//       currentPassword: "",
//       newPassword: "",
//       confirmPassword: "",
//     });
//     setShowPasswordModal(true);
//   };

//   const handleClosePasswordModal = () => {
//     setShowPasswordModal(false);
//   };

//   const handlePasswordInputChange = (e) => {
//     const { name, value } = e.target;
//     setPasswordForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setPwError("");
//     setPwSuccess("");

//     if (!passwordForm.currentPassword || !passwordForm.newPassword || !passwordForm.confirmPassword) {
//       setPwError("Please fill in all fields.");
//       return;
//     }

//     if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//       setPwError("New password and confirm password do not match.");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("adminToken");
//       await axios.post(
//         `${URL}/admins/me/change-password`,
//         {
//           currentPassword: passwordForm.currentPassword,
//           newPassword: passwordForm.newPassword,
//         },
//         {
//           headers: token ? { Authorization: `Bearer ${token}` } : {},
//         }
//       );
//       setPwSuccess("Password updated successfully.");
      
//       setPasswordForm({
//         currentPassword: "",
//         newPassword: "",
//         confirmPassword: "",
//       });
      
//       // Optionally also hide all eyes
//       setShowCurrentPassword(false);
//       setShowNewPassword(false);
//       setShowConfirmPassword(false);
      
//       // optional: close modal after a short delay or immediately:
//       // setShowPasswordModal(false);
//     } catch (err) {
//       console.error("Change password error:", err);
//       const msg = err.response?.data?.error || "Failed to change password.";
//       setPwError(msg);
//     }
//   };


//   return (
//     <>
//     <Navbar expand="lg" className="dashboard-topbar">
//       <Container fluid>
//         {/* <div className="d-flex align-items-center">
//           <div className="page-title">Admin Dashboard</div>
//         </div> */}
//         <Navbar.Toggle aria-controls="basic-navbar-nav" />
//         <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
//           <Nav className="align-items-center">
//             <div className="search-box me-3">
//               <i className="bi bi-search"></i>
//               <input type="text" placeholder="Search..." />
//             </div>

//             <Dropdown align="end" className="notification-dropdown me-3">
//               <Dropdown.Toggle
//                 variant="link"
//                 id="dropdown-notification"
//                 className="topbar-icon position-relative"
//               >
//                 <i className="bi bi-bell"></i>
//                 <span className="notification-badge">
//                   {notifications.length}
//                 </span>
//               </Dropdown.Toggle>

//               <Dropdown.Menu className="notification-menu">
//                 <div className="notification-header">
//                   <h6 className="mb-0">Notifications</h6>
//                   <small>{notifications.length} New</small>
//                 </div>
//                 <div className="notification-body">
//                   {notifications.length ? (
//                     notifications.map((notification) => (
//                       <Dropdown.Item
//                         key={notification.id}
//                         className="notification-item"
//                       >
//                         <div
//                           className={`notification-icon ${notification.type}`}
//                         >
//                           <i
//                             className={`bi ${getNotificationIcon(
//                               notification.type
//                             )}`}
//                           ></i>
//                         </div>
//                         <div className="notification-content">
//                           <p className="notification-text">
//                             {notification.message}
//                           </p>
//                           <small className="notification-time">
//                             {notification.time}
//                           </small>
//                         </div>
//                       </Dropdown.Item>
//                     ))
//                   ) : (
//                     <div className="no-notifications text-center p-3">
//                       No new notifications
//                     </div>
//                   )}
//                 </div>
//                 <div className="notification-footer d-flex justify-content-between align-items-center">
//                   <Link to="/notifications" className="view-all">
//                     View All Notifications
//                   </Link>
//                   {notifications.length > 0 && (
//                     <button
//                       onClick={handleClearNotifications}
//                       className="btn btn-link btn-sm"
//                     >
//                       Clear All
//                     </button>
//                   )}
//                 </div>
//               </Dropdown.Menu>
//             </Dropdown>

//             <Dropdown align="end" className="profile-dropdown">
//               <Dropdown.Toggle
//                 variant="link"
//                 id="dropdown-profile"
//                 className="topbar-profile"
//               >
//                 <div className="profile-img">
//                   <i className="bi bi-person-circle"></i>
//                 </div>
//                 <div className="profile-text d-none d-md-block">
//                   {/* <h6 className="mb-0">Admin User</h6> */}
//                   <h6 className="mb-0">{adminInfo?.name || "Admin User"}</h6>
//                   <small>{getRoleLabel(adminInfo?.role)}</small>

//                 </div>
//               </Dropdown.Toggle>

//               <Dropdown.Menu>
//                 <Dropdown.Item href="#profile">
//                   <i className="bi bi-person me-2"></i> My Profile
//                 </Dropdown.Item>

//                 <Dropdown.Item onClick={handleOpenPasswordModal}>
//                 <i className="bi bi-key me-2"></i> Change Password
//               </Dropdown.Item>

//                 <Dropdown.Item href="#settings">
//                   <i className="bi bi-gear me-2"></i> Settings
//                 </Dropdown.Item>
//                 <Dropdown.Divider />
//                 <Dropdown.Item
//                  onClick={() => {
//                     localStorage.removeItem("adminToken");
//                     localStorage.removeItem("adminInfo");
//                     window.location.href = "/HelpNaoadminpannel/login";
//                   }}
//                 >
//                   <i className="bi bi-box-arrow-right me-2"></i> Logout
//                 </Dropdown.Item>
//               </Dropdown.Menu>
//             </Dropdown>
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>

//     {/* Change Password Modal */}
//       <Modal show={showPasswordModal} onHide={handleClosePasswordModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Change Password</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {pwError && <div className="alert alert-danger">{pwError}</div>}
//           {pwSuccess && <div className="alert alert-success">{pwSuccess}</div>}

//           <Form onSubmit={handlePasswordSubmit}>
//             {/* Current Password */}
//             <Form.Group className="mb-3">
//               <Form.Label>Current Password</Form.Label>
//               <div className="position-relative">
//                 <Form.Control
//                   type={showCurrentPassword ? "text" : "password"}
//                   name="currentPassword"
//                   value={passwordForm.currentPassword}
//                   onChange={handlePasswordInputChange}
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-link position-absolute"
//                   style={{
//                     right: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     textDecoration: "none",
//                   }}
//                   onClick={() => setShowCurrentPassword((prev) => !prev)}
//                   tabIndex={-1}
//                 >
//                   <i
//                     className={`bi ${
//                       showCurrentPassword ? "bi-eye-slash" : "bi-eye"
//                     }`}
//                   ></i>
//                 </button>
//               </div>
//             </Form.Group>

//             {/* New Password */}
//             <Form.Group className="mb-3">
//               <Form.Label>New Password</Form.Label>
//               <div className="position-relative">
//                 <Form.Control
//                   type={showNewPassword ? "text" : "password"}
//                   name="newPassword"
//                   value={passwordForm.newPassword}
//                   onChange={handlePasswordInputChange}
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-link position-absolute"
//                   style={{
//                     right: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     textDecoration: "none",
//                   }}
//                   onClick={() => setShowNewPassword((prev) => !prev)}
//                   tabIndex={-1}
//                 >
//                   <i
//                     className={`bi ${
//                       showNewPassword ? "bi-eye-slash" : "bi-eye"
//                     }`}
//                   ></i>
//                 </button>
//               </div>
//             </Form.Group>

//             {/* Confirm New Password */}
//             <Form.Group className="mb-3">
//               <Form.Label>Confirm New Password</Form.Label>
//               <div className="position-relative">
//                 <Form.Control
//                   type={showConfirmPassword ? "text" : "password"}
//                   name="confirmPassword"
//                   value={passwordForm.confirmPassword}
//                   onChange={handlePasswordInputChange}
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-link position-absolute"
//                   style={{
//                     right: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     textDecoration: "none",
//                   }}
//                   onClick={() => setShowConfirmPassword((prev) => !prev)}
//                   tabIndex={-1}
//                 >
//                   <i
//                     className={`bi ${
//                       showConfirmPassword ? "bi-eye-slash" : "bi-eye"
//                     }`}
//                   ></i>
//                 </button>
//               </div>
//             </Form.Group>

//             <div className="d-flex justify-content-end">
//               <Button
//                 variant="secondary"
//                 className="me-2"
//                 onClick={handleClosePasswordModal}
//               >
//                 Cancel
//               </Button>
//               <Button variant="primary" type="submit">
//                 Update Password
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//     </>
//   );
// };

// const AdminDash = () => {
//   const location = useLocation();
//   const [adminInfo, setAdminInfo] = useState(null);

//   useEffect(() => {
//     const path = location.pathname.split("/").pop();
//     const title = path.charAt(0).toUpperCase() + path.slice(1);
//     document.title = `HelpNao Admin | ${title || "Dashboard"}`;
//   }, [location]);

//   useEffect(() => {
//     const stored = localStorage.getItem("adminInfo");
//     if (stored) {
//       try {
//         setAdminInfo(JSON.parse(stored));
//       } catch (e) {
//         console.error("Failed to parse adminInfo:", e);
//       }
//     }
//   }, []);

//   return (
//     <div className="admin-dashboard">
//       <DashboardSidebar adminInfo={adminInfo}/>
//       <div className="dashboard-content">
//         <DashboardTopBar adminInfo={adminInfo}/>
//         <div className="content-container">
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDash;


// ***** updated for protected and Notification count (10-Dec-2025) ***** //
import React, { useState, useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Navbar, Nav, Container, Dropdown, Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./AdminDash.css";
import axios from "axios";
import { URL } from "../../config";
import SEO from "../../Components/SEO/SEO";

const getRoleLabel = (role) => {
  switch (Number(role)) {
    case 1:
      return "Founder";
    case 2:
      return "Super Admin";
    case 3:
      return "Admin";
    default:
      return "Admin";
  }
};

const DashboardSidebar = ({ adminInfo, isMobile, mobileOpen, setMobileOpen }) => {
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [servitorDropdownOpen, setServitorDropdownOpen] = useState(false);
  const [reportsDropdownOpen, setReportsDropdownOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const role = Number(adminInfo?.role);
  const isFounder = role === 1;
  const isSuperAdmin = role === 2;
  const canSeeCoreAdminLinks = isFounder || isSuperAdmin; // Founder + Super Admin

  const [openReportsCount, setOpenReportsCount] = useState(0);
  const [newContactsCount, setNewContactsCount] = useState(0);
  const [pendingFullBuildingCount, setPendingFullBuildingCount] = useState(0);
  const [initRechargesCount, setInitRechargesCount] = useState(0);
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);
  const [pendingServitorsCount, setPendingServitorsCount] = useState(0);


  const hasUserAlerts = pendingOrdersCount > 0;
  const hasServitorAlerts = pendingServitorsCount > 0;
  // const hasReportsAlerts = initRechargesCount > 0; 




  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
    if (servitorDropdownOpen) setServitorDropdownOpen(false);
  };

  const toggleServitorDropdown = () => {
    setServitorDropdownOpen(!servitorDropdownOpen);
    if (userDropdownOpen) setUserDropdownOpen(false);
  };

   const toggleReportsDropdown = () => {
    setReportsDropdownOpen(!reportsDropdownOpen);
    if (userDropdownOpen) setUserDropdownOpen(false);
    if (servitorDropdownOpen) setServitorDropdownOpen(false);
  };

  // const toggleSidebar = () => {
  //   setCollapsed(!collapsed);
  // };

  const toggleSidebar = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setCollapsed(!collapsed);
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isInDropdown = (paths) => {
    return paths.some((path) => location.pathname.includes(path));
  };

    useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (!token) return;

    let cancelled = false;
    const authHeaders = { Authorization: `Bearer ${token}` };

    // Define all badge endpoints + their setter + response key
    const endpoints = [
      {
        url: "/admin/helpsupport/reports/open-count",
        setter: setOpenReportsCount,
        field: "openCount",
      },
      {
        url: "/admin/contacts/new-count",
        setter: setNewContactsCount,
        field: "newCount",
      },
      {
        url: "/admin/full-building/pending-count",
        setter: setPendingFullBuildingCount,
        field: "pendingCount",
      },
      {
        url: "/admin/recharges/init-count",
        setter: setInitRechargesCount,
        field: "initCount",
      },
      {
        url: "/admin/orders/pending-count",
        setter: setPendingOrdersCount,
        field: "pendingCount",
      },
      {
        url: "/admin/servitors/pending-count",
        setter: setPendingServitorsCount,
        field: "pendingCount",
      },
    ];

    const fetchOne = async (endpoint) => {
      try {
        const res = await axios.get(`${URL}${endpoint.url}`, {
          headers: authHeaders,
        });
        if (!cancelled) {
          const value = res.data?.[endpoint.field];
          endpoint.setter(Number.isFinite(value) ? value : 0);
        }
      } catch (err) {
        console.error(`Failed to fetch ${endpoint.url}:`, err);
      }
    };

    // Initial load: fetch all in parallel
    const runInitial = async () => {
      await Promise.all(endpoints.map((ep) => fetchOne(ep)));
    };
    runInitial();

    // Poll each endpoint every 30 seconds
    const intervalIds = endpoints.map((ep) =>
      setInterval(() => fetchOne(ep), 30000)
    );

    // Cleanup on unmount
    return () => {
      cancelled = true;
      intervalIds.forEach(clearInterval);
    };
  }, []);



  return (
    // <div className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}>
    <div
      className={`admin-sidebar ${collapsed ? "collapsed" : ""} ${
        isMobile && mobileOpen ? "show" : ""
      }`}
    >
      <div className="admin-sidebar-header">
        <div className="d-flex align-items-center justify-content-between">
          <span className="admin-sidebar-brand">
            <i className="bi bi-grid-fill me-2"></i>
            {!collapsed && "HelpNao"}
          </span>
          <button className="admin-toggle-btn" onClick={toggleSidebar}>
            <i
              className={`bi ${
                collapsed ? "bi-chevron-right" : "bi-chevron-left"
              }`}
            ></i>
          </button>
        </div>
      </div>
      <div className="admin-sidebar-profile">
        <div className="admin-profile-avatar">
          <i className="bi bi-person-circle"></i>
        </div>
        {/* {!collapsed && (
          <div className="admin-profile-info">
            <h6 className="admin-profile-name">Admin User</h6>
            <span className="admin-profile-role">Administrator</span>
          </div>
        )} */}

        {!collapsed && (
          <div className="admin-profile-info">
            <span className="admin-profile-role">
              {getRoleLabel(adminInfo?.role)}
            </span>
            <h6 className="admin-profile-name">
              {adminInfo?.name || "Admin User"}
            </h6>
            {adminInfo?.email && (
              <small className="text-muted d-block" style={{ fontSize: "10px" }}>
                {adminInfo.email}
              </small>
            )}
          </div>
        )}


      </div>
      <hr className="admin-sidebar-divider" />
      <ul className="admin-sidebar-nav">
        <li className="admin-nav-item">
          <Link
            to="/admin/dashboard"
            className={`admin-nav-link ${
              isActive("/admin/dashboard") ? "active" : ""
            }`}
          >
            <i className="bi bi-house-door-fill"></i>
            {!collapsed && <span>Dashboard</span>}
          </Link>
        </li>

       {canSeeCoreAdminLinks && ( 
        <li className="admin-nav-item">
          <Link
            to="/admin/helpnaoadmins"
            className={`admin-nav-link ${isActive("/admin/helpnaoadmins") ? "active" : ""}`}
          >
            <i className="bi bi-shield-lock-fill"></i>
            {!collapsed && <span>All Admins</span>}
          </Link>
        </li>
       )}

       {canSeeCoreAdminLinks && ( 
        <li className="admin-nav-item">
          <Link
            to="/admin/helpnaoadmins/adminactivity"
            className={`admin-nav-link ${isActive("/admin/helpnaoadmins/adminactivity") ? "active" : ""}`}
          >
            <i className="bi bi-activity"></i>
            {!collapsed && <span>Admins Activity</span>}
          </Link>
        </li>
       )}


       {canSeeCoreAdminLinks && ( 
        <li className="admin-nav-item">
          <Link
            to="/admin/services"
            className={`admin-nav-link ${
              isActive("/admin/services") ? "active" : ""
            }`}
          >
            <i className="bi bi-tools"></i>
            {!collapsed && <span>Services</span>}
          </Link>
        </li>
       )}

       {canSeeCoreAdminLinks && ( 
        <li className="admin-nav-item">
          <Link
            to="/admin/location"
            className={`admin-nav-link ${
              isActive("/admin/location") ? "active" : ""
            }`}
          >
            <i className="bi bi-geo-alt-fill"></i>
            {!collapsed && <span>Location</span>}
          </Link>
        </li>
       )}

        {/* <li className="admin-nav-item">
          <div
            className={`admin-nav-link admin-dropdown-toggle ${
              isInDropdown(["/admin/userdetails", "/admin/userorders"]) ||
              userDropdownOpen
                ? "active"
                : ""
            }`}
            onClick={toggleUserDropdown}
          >
            <i className="bi bi-person-fill"></i>
            {!collapsed && (
              <>
                <span>User</span>
                <i
                  className={`bi bi-chevron-${
                    userDropdownOpen ? "down" : "right"
                  } ms-auto`}
                ></i>
              </>
            )}
          </div> */}

        <li className="admin-nav-item">
          <div
            className={`admin-nav-link admin-dropdown-toggle ${
              isInDropdown(["/admin/userdetails", "/admin/userorders"]) ||
              userDropdownOpen
                ? "active"
                : ""
            } ${hasUserAlerts ? "has-alert" : ""}`}
            onClick={toggleUserDropdown}
          >
            <i className="bi bi-person-fill"></i>

            {!collapsed && (
              <>
                <span>User</span>
                {hasUserAlerts && (
                  <span className="admin-new-badge">NEW</span>
                )}
                <i
                  className={`bi bi-chevron-${
                    userDropdownOpen ? "down" : "right"
                  } ms-auto`}
                ></i>
              </>
            )}


            {/* When collapsed, show a small dot on the icon if any user alerts */}
            {collapsed && hasUserAlerts && (
              <span className="admin-badge-dot" />
            )}
          </div>

          <ul className={`admin-dropdown-menu ${userDropdownOpen ? "active" : ""}`}>
            <li className="admin-dropdown-item">
              <Link
                to="/admin/userdetails"
                className={`admin-nav-link ${
                  isActive("/admin/userdetails") ? "active" : ""
                }`}
              >
                <i className="bi bi-person-vcard"></i>
                <span>User Details</span>
              </Link>
            </li>
            <li className="admin-dropdown-item">
              <Link
                to="/admin/placeordersforuser"
                className={`admin-nav-link ${
                  isActive("/admin/placeordersforuser") ? "active" : ""
                }`}
              >
                <i className="bi bi-cart-check"></i>
                <span>Place Order</span>
              </Link>
            </li>

            {/* <li className="admin-dropdown-item">
              <Link
                to="/admin/userorders"
                className={`admin-nav-link ${
                  isActive("/admin/userorders") ? "active" : ""
                }`}
              >
                <i className="bi bi-bag-check"></i>
                <span>User Orders</span>
              </Link>
            </li> */}

            <li className="admin-dropdown-item">
              <Link
                to="/admin/userorders"
                className={`admin-nav-link ${
                  isActive("/admin/userorders") ? "active" : ""
                }`}
              >
                <i className="bi bi-bag-check"></i>

                {/* Full label + badge when sidebar expanded */}
                {!collapsed && (
                  <>
                    <span>User Orders</span>
                    {pendingOrdersCount > 0 && (
                      <span className="admin-badge-pulse">
                        {pendingOrdersCount > 99 ? "99+" : pendingOrdersCount}
                      </span>
                    )}
                  </>
                )}

                {/* Only small dot when collapsed */}
                {collapsed && pendingOrdersCount > 0 && (
                  <span className="admin-badge-dot" />
                )}
              </Link>
            </li>


          </ul>
        </li>

        {/* <li className="admin-nav-item">
          <div
            className={`admin-nav-link admin-dropdown-toggle ${
              isInDropdown([
                "/admin/servitordetails",
                "/admin/servitorconfirmorders",
              ]) || servitorDropdownOpen
                ? "active"
                : ""
            }`}
            onClick={toggleServitorDropdown}
          >
            <i className="bi bi-people-fill"></i>
            {!collapsed && (
              <>
                <span>Servitor</span>
                <i
                  className={`bi bi-chevron-${
                    servitorDropdownOpen ? "down" : "right"
                  } ms-auto`}
                ></i>
              </>
            )}
          </div> */}

                  <li className="admin-nav-item">
          <div
            className={`admin-nav-link admin-dropdown-toggle ${
              isInDropdown([
                "/admin/servitordetails",
                "/admin/servitorconfirmorders",
                "/admin/servitororderhistory",
                "/admin/servitor-referral",
                "/admin/servitorfeedbackdetails",
              ]) || servitorDropdownOpen
                ? "active"
                : ""
            } ${hasServitorAlerts ? "has-alert" : ""}`}
            onClick={toggleServitorDropdown}
          >
            <i className="bi bi-people-fill"></i>

            {!collapsed && (
              <>
                <span>Servitor</span>
                {hasServitorAlerts && (
                  <span className="admin-new-badge">NEW</span>
                )}
                <i
                  className={`bi bi-chevron-${
                    servitorDropdownOpen ? "down" : "right"
                  } ms-auto`}
                ></i>
              </>
            )}



            {/* Tiny dot on icon when collapsed */}
            {collapsed && hasServitorAlerts && (
              <span className="admin-badge-dot" />
            )}
          </div>


          <ul
            className={`admin-dropdown-menu ${servitorDropdownOpen ? "active" : ""}`}
          >
            {/* <li className="admin-dropdown-item">
              <Link
                to="/admin/servitordetails"
                className={`admin-nav-link ${
                  isActive("/admin/servitordetails") ? "active" : ""
                }`}
              >
                <i className="bi bi-person-badge"></i>
                <span>Details</span>
              </Link>
            </li> */}

            <li className="admin-dropdown-item">
                <Link
                  to="/admin/servitordetails"
                  className={`admin-nav-link ${
                    isActive("/admin/servitordetails") ? "active" : ""
                  }`}
                >
                  <i className="bi bi-person-badge"></i>

                  {/* Full label + badge when sidebar expanded */}
                  {!collapsed && (
                    <>
                      <span>Details</span>
                      {pendingServitorsCount > 0 && (
                        <span className="admin-badge-pulse">
                          {pendingServitorsCount > 99 ? "99+" : pendingServitorsCount}
                        </span>
                      )}
                    </>
                  )}

                  {/* Tiny dot when sidebar is collapsed */}
                  {collapsed && pendingServitorsCount > 0 && (
                    <span className="admin-badge-dot" />
                  )}
                </Link>
              </li>


            <li className="admin-dropdown-item">
              <Link
                to="/admin/servitorconfirmorders"
                className={`admin-nav-link ${
                  isActive("/admin/servitorconfirmorders") ? "active" : ""
                }`}
              >
                <i className="bi bi-check-circle"></i>
                <span>Confirm Orders</span>
              </Link>
            </li>

            <li className="admin-dropdown-item">
              <Link
                to="/admin/servitororderhistory"
                className={`admin-nav-link ${
                  isActive("/admin/servitororderhistory") ? "active" : ""
                }`}
              >
                {/* <i className="bi bi-check-circle"></i> */}
                <i className="bi bi-journal-check"></i>
                <span>Orders History</span>
              </Link>
            </li>
            <li className="admin-dropdown-item">
              <Link
                to="/admin/servitor-referral"
                className={`admin-nav-link ${
                  isActive("/admin/servitor-referral") ? "active" : ""
                }`}
              >
                {/* <i className="bi bi-check-circle"></i> */}
                <i className="bi bi-people"></i>
                <span>Referral Details</span>
              </Link>
            </li>
            <li className="admin-dropdown-item">
              <Link
                to="/admin/servitorfeedbackdetails"
                className={`admin-nav-link ${
                  isActive("/admin/servitorfeedbackdetails") ? "active" : ""
                }`}
              >
                {/* <i className="bi bi-check-circle"></i> */}
                <i className="bi bi-chat-left-text"></i>
                <span>Rating & Feedback</span>
              </Link>
            </li>

          </ul>
        </li>
        {/* <li className="admin-nav-item">
          <Link
            to="/admin/reports"
            className={`admin-nav-link ${
              isActive("/admin/reports") ? "active" : ""
            }`}
          >
            <i className="bi bi-bar-chart-line-fill"></i>
            {!collapsed && <span>Reports</span>}
          </Link>
        </li>
        <li className="admin-nav-item">
          <Link
            to="/admin/reports/financereport"
            className={`admin-nav-link ${
              isActive("/admin/reports/financereport") ? "active" : ""
            }`}
          >
            <i className="bi bi-bar-chart-line-fill"></i>
            {!collapsed && <span>Finance Reports</span>}
          </Link>
        </li>
        <li className="admin-nav-item">
          <Link
            to="/admin/reports/rechargeamount"
            className={`admin-nav-link ${
              isActive("/admin/reports/rechargeamount") ? "active" : ""
            }`}
          >
            <i className="bi bi-bar-chart-line-fill"></i>
            {!collapsed && <span>Recharge Reports</span>}
          </Link>
        </li> */}


        {/* <li className="admin-nav-item">
          <Link
            to="/admin/full-building-requests"
            className={`admin-nav-link ${
              isActive("/admin/full-building-requests") ? "active" : ""
            }`}
          >
            <i className="bi bi-building"></i>
            {!collapsed && <span>Full Building</span>}
          </Link>
        </li> */}


        <li className="admin-nav-item">
          <Link
            to="/admin/full-building-requests"
            className={`admin-nav-link ${
              isActive("/admin/full-building-requests") ? "active" : ""
            }`}
          >
            <i className="bi bi-building"></i>

            {/* Full label + badge when sidebar expanded */}
            {!collapsed && (
              <>
                <span>Full Building</span>
                {pendingFullBuildingCount > 0 && (
                  <span className="admin-badge-pulse">
                    {pendingFullBuildingCount > 99 ? "99+" : pendingFullBuildingCount}
                  </span>
                )}
              </>
            )}

            {/* Small dot when collapsed */}
            {collapsed && pendingFullBuildingCount > 0 && (
              <span className="admin-badge-dot" />
            )}
          </Link>
        </li>


        {/* Recharge Report with INIT badge */}
              <li className="admin-dropdown-item">
                <Link
                  to="/admin/reports/rechargeamount"
                  className={`admin-nav-link ${
                    isActive("/admin/reports/rechargeamount") ? "active" : ""
                  }`}
                >
                  <i className="bi bi-lightning-charge"></i>

                  {/* Full label + badge when sidebar expanded */}
                  {!collapsed && (
                    <>
                      <span>Recharge Report</span>
                      {initRechargesCount > 0 && (
                        <span className="admin-badge-pulse">
                          {initRechargesCount > 99 ? "99+" : initRechargesCount}
                        </span>
                      )}
                    </>
                  )}

                  {/* Small dot when collapsed */}
                  {collapsed && initRechargesCount > 0 && (
                    <span className="admin-badge-dot" />
                  )}
                </Link>
              </li>




         <li className="admin-nav-item">
          <div
            className={`admin-nav-link admin-dropdown-toggle ${
              isInDropdown([
                "/admin/reports",
                "/admin/reports/financereport",
                "/admin/reports/rechargeamount",
              ]) || reportsDropdownOpen
                ? "active"
                : ""
            }`}
            onClick={toggleReportsDropdown}
          >
            <i className="bi bi-graph-up"></i>
            {!collapsed && (
              <>
                <span>Reports</span>
                <i className={`bi bi-chevron-${reportsDropdownOpen ? "down" : "right"} ms-auto`}></i>
              </>
            )}
          </div>
          <ul className={`admin-dropdown-menu ${reportsDropdownOpen ? "active" : ""}`}>
            {/* Transaction Report (root reports) */}
            <li className="admin-dropdown-item">
              <Link
                to="/admin/reports"
                className={`admin-nav-link ${isActive("/admin/reports") ? "active" : ""}`}
              >
                <i className="bi bi-receipt"></i>
                <span>Transaction Report</span>
              </Link>
            </li>

            {/* Recharge Report */}
            {/* <li className="admin-dropdown-item">
              <Link
                to="/admin/reports/rechargeamount"
                className={`admin-nav-link ${isActive("/admin/reports/rechargeamount") ? "active" : ""}`}
              >
                <i className="bi bi-lightning-charge"></i>
                <span>Recharge Report</span>
              </Link>
            </li> */}

            {/* *****Must keep this We will keep it Recharge Report ****** */}
              {/* <li className="admin-dropdown-item">
                <Link
                  to="/admin/reports/rechargeamount"
                  className={`admin-nav-link ${
                    isActive("/admin/reports/rechargeamount") ? "active" : ""
                  }`}
                >
                  <i className="bi bi-lightning-charge"></i>

                  {!collapsed && (
                    <>
                      <span>Recharge Report</span>
                      {initRechargesCount > 0 && (
                        <span className="admin-badge-pulse">
                          {initRechargesCount > 99 ? "99+" : initRechargesCount}
                        </span>
                      )}
                    </>
                  )}

                  {collapsed && initRechargesCount > 0 && (
                    <span className="admin-badge-dot" />
                  )}
                </Link>
              </li> */}



            {/* Finance Report */}
            <li className="admin-dropdown-item">
              <Link
                to="/admin/reports/financereport"
                className={`admin-nav-link ${isActive("/admin/reports/financereport") ? "active" : ""}`}
              >
                <i className="bi bi-wallet2"></i>
                <span>Finance Report</span>
              </Link>
            </li>

          </ul>
        </li>


        {/* <li className="admin-nav-item">
          <Link
            to="/admin/helpsupport/reports"
            className={`admin-nav-link ${
              isActive("/admin/helpsupport/reports") ? "active" : ""
            }`}
          >
            <i class="bi bi-headset"></i>
            {!collapsed && <span>Issue Reports</span>}
          </Link>
        </li> */}


        <li className="admin-nav-item">
          <Link
            to="/admin/helpsupport/reports"
            className={`admin-nav-link ${
              isActive("/admin/helpsupport/reports") ? "active" : ""
            }`}
          >
            <i className="bi bi-headset"></i>

            {/* Full label + badge when sidebar expanded */}
            {!collapsed && (
              <>
                <span>Issue Reports</span>
                {openReportsCount > 0 && (
                  <span className="admin-badge-pulse">
                    {openReportsCount > 99 ? "99+" : openReportsCount}
                  </span>
                )}
              </>
            )}

            {/* Small dot when collapsed (no text) */}
            {collapsed && openReportsCount > 0 && (
              <span className="admin-badge-dot" />
            )}
          </Link>
        </li>



        {/* <li className="admin-nav-item">
          <Link
            to="/admin/helpsupport/contactuslist"
            className={`admin-nav-link ${
              isActive("/admin/helpsupport/contactuslist") ? "active" : ""
            }`}
          >
            <i className="bi bi-chat-left-dots"></i>
            {!collapsed && <span>Contact Message</span>}
          </Link>
        </li> */}


        <li className="admin-nav-item">
          <Link
            to="/admin/helpsupport/contactuslist"
            className={`admin-nav-link ${
              isActive("/admin/helpsupport/contactuslist") ? "active" : ""
            }`}
          >
            <i className="bi bi-chat-left-dots"></i>

            {/* Full label + badge when sidebar expanded */}
            {!collapsed && (
              <>
                <span>Contact Message</span>
                {newContactsCount > 0 && (
                  <span className="admin-badge-pulse">
                    {newContactsCount > 99 ? "99+" : newContactsCount}
                  </span>
                )}
              </>
            )}

            {/* Only small animated dot when collapsed */}
            {collapsed && newContactsCount > 0 && (
              <span className="admin-badge-dot" />
            )}
          </Link>
        </li>

        {/* {canSeeCoreAdminLinks && (  */}
        <li className="admin-nav-item">
          <Link
            to="/admin/checkreports/notifications-all"
            className={`admin-nav-link ${
              isActive("/admin/checkreports/notifications-all") ? "active" : ""
            }`}
          >
            <i className="bi bi-envelope-exclamation"></i>

            {!collapsed && <span>All Notifications</span>}
          </Link>
        </li>
       {/* )} */}

        

      </ul>
      <div className="admin-sidebar-footer">
        <div
          className="admin-logout-btn"
          onClick={() => {
                    localStorage.removeItem("adminToken");
                    localStorage.removeItem("adminInfo");
                    localStorage.removeItem("token");
                    localStorage.removeItem("role");
                    sessionStorage.clear();
                    window.location.href = "/HelpNaoadminpannel/login";
                  }}
        >
          <i className="bi bi-box-arrow-right"></i>
          {!collapsed && <span>Logout</span>}
        </div>
      </div>
    </div>
  );
};

const DashboardTopBar = ({ adminInfo, isMobile, onToggleSidebar }) => {
  const [notifications, setNotifications] = useState([
    { id: 1, message: "New user registered", time: "2 min ago", type: "user" },
    { id: 2, message: "New order placed", time: "10 min ago", type: "order" },
    {
      id: 3,
      message: "System update completed",
      time: "1 hour ago",
      type: "system",
    },
  ]);

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [pwError, setPwError] = useState("");
  const [pwSuccess, setPwSuccess] = useState("");


  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const getNotificationIcon = (type) => {
    switch (type) {
      case "user":
        return "bi-person-plus";
      case "order":
        return "bi-bag-plus";
      case "system":
        return "bi-gear";
      default:
        return "bi-bell";
    }
  };

  const handleClearNotifications = () => {
    setNotifications([]);
  };


    const handleOpenPasswordModal = () => {
    setPwError("");
    setPwSuccess("");
    setPasswordForm({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
    setShowPasswordModal(true);
  };

  const handleClosePasswordModal = () => {
    setShowPasswordModal(false);
  };

  const handlePasswordInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPwError("");
    setPwSuccess("");

    if (!passwordForm.currentPassword || !passwordForm.newPassword || !passwordForm.confirmPassword) {
      setPwError("Please fill in all fields.");
      return;
    }

    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPwError("New password and confirm password do not match.");
      return;
    }

    try {
      const token = localStorage.getItem("adminToken");
      await axios.post(
        `${URL}/admins/me/change-password`,
        {
          currentPassword: passwordForm.currentPassword,
          newPassword: passwordForm.newPassword,
        },
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      setPwSuccess("Password updated successfully.");
      
      setPasswordForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      
      // Optionally also hide all eyes
      setShowCurrentPassword(false);
      setShowNewPassword(false);
      setShowConfirmPassword(false);
      
      // optional: close modal after a short delay or immediately:
      // setShowPasswordModal(false);
    } catch (err) {
      console.error("Change password error:", err);
      const msg = err.response?.data?.error || "Failed to change password.";
      setPwError(msg);
    }
  };


  return (
    <>
    <Navbar expand="lg" className="dashboard-topbar">
      <Container fluid>
        {/* <div className="d-flex align-items-center">
          <div className="page-title">Admin Dashboard</div>
        </div> */}

        {isMobile && (
            <button
              type="button"
              className="admin-mobile-toggle"
              onClick={onToggleSidebar}
              aria-label="Toggle sidebar"
            >
              <i className="bi bi-list"></i>
            </button>
          )}

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="align-items-center">
            <div className="search-box me-3">
              <i className="bi bi-search"></i>
              <input type="text" placeholder="Search..." />
            </div>

            <Dropdown align="end" className="notification-dropdown me-3">
              <Dropdown.Toggle
                variant="link"
                id="dropdown-notification"
                className="topbar-icon position-relative"
              >
                <i className="bi bi-bell"></i>
                <span className="notification-badge">
                  {notifications.length}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="notification-menu">
                <div className="notification-header">
                  <h6 className="mb-0">Notifications</h6>
                  <small>{notifications.length} New</small>
                </div>
                <div className="notification-body">
                  {notifications.length ? (
                    notifications.map((notification) => (
                      <Dropdown.Item
                        key={notification.id}
                        className="notification-item"
                      >
                        <div
                          className={`notification-icon ${notification.type}`}
                        >
                          <i
                            className={`bi ${getNotificationIcon(
                              notification.type
                            )}`}
                          ></i>
                        </div>
                        <div className="notification-content">
                          <p className="notification-text">
                            {notification.message}
                          </p>
                          <small className="notification-time">
                            {notification.time}
                          </small>
                        </div>
                      </Dropdown.Item>
                    ))
                  ) : (
                    <div className="no-notifications text-center p-3">
                      No new notifications
                    </div>
                  )}
                </div>
                <div className="notification-footer d-flex justify-content-between align-items-center">
                  <Link to="/notifications" className="view-all">
                    View All Notifications
                  </Link>
                  {notifications.length > 0 && (
                    <button
                      onClick={handleClearNotifications}
                      className="btn btn-link btn-sm"
                    >
                      Clear All
                    </button>
                  )}
                </div>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown align="end" className="profile-dropdown">
              <Dropdown.Toggle
                variant="link"
                id="dropdown-profile"
                className="topbar-profile"
              >
                <div className="profile-img">
                  <i className="bi bi-person-circle"></i>
                </div>
                <div className="profile-text d-none d-md-block">
                  {/* <h6 className="mb-0">Admin User</h6> */}
                  <h6 className="mb-0">{adminInfo?.name || "Admin User"}</h6>
                  <small>{getRoleLabel(adminInfo?.role)}</small>

                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#profile">
                  <i className="bi bi-person me-2"></i> My Profile
                </Dropdown.Item>

                <Dropdown.Item onClick={handleOpenPasswordModal}>
                <i className="bi bi-key me-2"></i> Change Password
              </Dropdown.Item>

                <Dropdown.Item href="#settings">
                  <i className="bi bi-gear me-2"></i> Settings
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                 onClick={() => {
                    localStorage.removeItem("adminToken");
                    localStorage.removeItem("adminInfo");
                    localStorage.removeItem("token");
                    localStorage.removeItem("role");
                    sessionStorage.clear();
                    window.location.href = "/HelpNaoadminpannel/login";
                  }}
                >
                  <i className="bi bi-box-arrow-right me-2"></i> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

    {/* Change Password Modal */}
      <Modal show={showPasswordModal} onHide={handleClosePasswordModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pwError && <div className="alert alert-danger">{pwError}</div>}
          {pwSuccess && <div className="alert alert-success">{pwSuccess}</div>}

          <Form onSubmit={handlePasswordSubmit}>
            {/* Current Password */}
            <Form.Group className="mb-3">
              <Form.Label>Current Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showCurrentPassword ? "text" : "password"}
                  name="currentPassword"
                  value={passwordForm.currentPassword}
                  onChange={handlePasswordInputChange}
                  required
                />
                <button
                  type="button"
                  className="btn btn-sm btn-link position-absolute"
                  style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    textDecoration: "none",
                  }}
                  onClick={() => setShowCurrentPassword((prev) => !prev)}
                  tabIndex={-1}
                >
                  <i
                    className={`bi ${
                      showCurrentPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </button>
              </div>
            </Form.Group>

            {/* New Password */}
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showNewPassword ? "text" : "password"}
                  name="newPassword"
                  value={passwordForm.newPassword}
                  onChange={handlePasswordInputChange}
                  required
                />
                <button
                  type="button"
                  className="btn btn-sm btn-link position-absolute"
                  style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    textDecoration: "none",
                  }}
                  onClick={() => setShowNewPassword((prev) => !prev)}
                  tabIndex={-1}
                >
                  <i
                    className={`bi ${
                      showNewPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </button>
              </div>
            </Form.Group>

            {/* Confirm New Password */}
            <Form.Group className="mb-3">
              <Form.Label>Confirm New Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={passwordForm.confirmPassword}
                  onChange={handlePasswordInputChange}
                  required
                />
                <button
                  type="button"
                  className="btn btn-sm btn-link position-absolute"
                  style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    textDecoration: "none",
                  }}
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  tabIndex={-1}
                >
                  <i
                    className={`bi ${
                      showConfirmPassword ? "bi-eye-slash" : "bi-eye"
                    }`}
                  ></i>
                </button>
              </div>
            </Form.Group>

            <div className="d-flex justify-content-end">
              <Button
                variant="secondary"
                className="me-2"
                onClick={handleClosePasswordModal}
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Update Password
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

    </>
  );
};

const AdminDash = () => {
  const location = useLocation();
  const [adminInfo, setAdminInfo] = useState(null);

  // responsive sidebar
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false);

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    const title = path.charAt(0).toUpperCase() + path.slice(1);
    document.title = `HelpNao Admin | ${title || "Dashboard"}`;
  }, [location]);

  useEffect(() => {
    const stored = localStorage.getItem("adminInfo");
    if (stored) {
      try {
        setAdminInfo(JSON.parse(stored));
      } catch (e) {
        console.error("Failed to parse adminInfo:", e);
      }
    }
  }, []);


    useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) {
        // when going back to desktop, close overlay menu
        setSidebarMobileOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // When route changes on mobile, auto-close the sidebar overlay
    if (isMobile) {
      setSidebarMobileOpen(false);
    }
  }, [location.pathname, isMobile]);


  return (
    <>
    <SEO title="Admin Panel | HelpNao" path="/admin" noindex />
    <div className="admin-dashboard">
      <DashboardSidebar adminInfo={adminInfo}
        isMobile={isMobile}                 
        mobileOpen={sidebarMobileOpen}      
        setMobileOpen={setSidebarMobileOpen} 
      />
      {isMobile && sidebarMobileOpen && (
        <div
          className="admin-backdrop"
          onClick={() => setSidebarMobileOpen(false)}
        />
      )}
      <div className="dashboard-content">
        <DashboardTopBar adminInfo={adminInfo}
          isMobile={isMobile}                               
            onToggleSidebar={() =>
              setSidebarMobileOpen((prev) => !prev)           
          }/>
        <div className="content-container">
          <Outlet />
        </div>
      </div>
    </div>
    </>
  );
};

export default AdminDash;
